<div
  id="userSettings"
  class="page-layout blank p-24"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'USERS.SETTINGS.TITLE' | translate }}
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content" fxLayout="row wrap">
    <!-- CONTENT CARD -->
    <div class="content-card" fxFill>
      @if (isLoading) {
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
          class="mat-progress-bar"></mat-progress-bar>
      } @else {
        <div class="content">
          <mat-tab-group
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            fxLayout="column"
            fxFlex
            fxFill
            [selectedIndex]="selectedIndex"
            (selectedTabChange)="tabChanged($event)">
            <mat-tab label="{{ 'USERS.SETTINGS.TABS1.TITLE' | translate }} ">
              <div class="content" fxLayout="row wrap">
                <div
                  ffxLayout="column"
                  fxFlex="60"
                  fxFlex.xl="33"
                  fxFlex.sm="100"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="mat-card profile-card">
                    <div class="box-container">
                      <div>
                        @if (currentUser.groupEtablissement.length > 0) {
                          <div>
                            <h3 class="settingsTitles">
                              {{
                                'USERS.SETTINGS.TABS1.BASESETTINGS.GE'
                                  | translate
                              }}
                            </h3>
                            @if (newEtablissement !== null) {
                              <mat-form-field
                                appearance="fill"
                                class="simplified">
                                <mat-select
                                  class="select-user-etab"
                                  [(ngModel)]="newEtablissement"
                                  (selectionChange)="isSaveDisabled()"
                                  [disabled]="isLoading || !hasMultiEtab">
                                  @for (
                                    item of currentUser.groupEtablissement;
                                    track $index
                                  ) {
                                    <mat-option [value]="item">
                                      {{ item }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                          </div>
                        }
                        <div>
                          <h3 class="settingsTitles">
                            {{
                              'USERS.SETTINGS.TABS1.BASESETTINGS.DISPLAYMODE'
                                | translate
                            }}
                          </h3>
                          <div class="displayModes">
                            <button
                              (click)="onDisplayModeChange(0)"
                              class="display-btn">
                              <img
                                src="../../../assets/images/affichagesTuiles/grand_brique.svg"
                                class="displayModeImage"
                                alt="Grandes icones"
                                [ngClass]="{
                                  selected: newAffichageMode === 0,
                                }" />
                              <div class="icon-text">
                                {{
                                  'USERS.SETTINGS.TABS1.BASESETTINGS.MAXI'
                                    | translate
                                }}
                              </div>
                            </button>
                            <button
                              (click)="onDisplayModeChange(1)"
                              class="display-btn">
                              <img
                                src="../../../assets/images/affichagesTuiles/petite_brique.svg"
                                class="displayModeImage"
                                alt="Petites icones"
                                [ngClass]="{
                                  selected: newAffichageMode === 1,
                                }" />
                              <div class="icon-text">
                                {{
                                  'USERS.SETTINGS.TABS1.BASESETTINGS.MINI'
                                    | translate
                                }}
                              </div>
                            </button>
                            <button
                              (click)="onDisplayModeChange(2)"
                              class="display-btn">
                              <img
                                src="../../../assets/images/affichagesTuiles/liste.svg"
                                class="displayModeImage"
                                alt="Liste"
                                [ngClass]="{
                                  selected: newAffichageMode === 2,
                                }" />
                              <div class="icon-text">
                                {{
                                  'USERS.SETTINGS.TABS1.BASESETTINGS.LIST'
                                    | translate
                                }}
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        mat-raised-button
                        color="accent"
                        (click)="saveSettings()"
                        class="save-btn"
                        [disabled]="saveDisabled">
                        {{ 'GENERAL.SAVE' | translate }}
                      </button>
                    </div>
                  </mat-card>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
  </div>
</div>
